<template>
  <v-dialog v-model="isActive" fullscreen hide-overlay transition="dialog-bottom-transition" scrollable>
    <v-card>
      <div class="header">
        <div class="content-header">
          <div @click="close()" class="return-screen">
            <v-icon color="white">mdi-close</v-icon>
          </div>
          <h2>Desconto</h2>
          <div>Atrelar desconto ao orçamento selecionado</div>
        </div>
      </div>
      <v-form>
        <!-- Tabs para novo modo (separado por serviço/produto) -->
        <v-tabs
          v-if="!isLegacyMode"
          v-model="activeTab"
          class="discount-tabs"
          grow
          background-color="#f4f4f4"
        >
          <v-tab>SERVIÇO</v-tab>
          <v-tab>PRODUTO</v-tab>
        </v-tabs>

        <v-container class="type-selector">
          <v-radio-group
            v-model="currentDiscountType"
            row
            @change="toggleDiscountType"
          >
            <v-radio label="Percentual" value="percentual"></v-radio>
            <v-radio label="Valor" value="valor"></v-radio>
          </v-radio-group>
        </v-container>
        <v-card-text class="px-4 py-4">
          <v-text-field
            :key="'discount-input-' + activeTab"
            ref="discountValue"
            type="text"
            v-model="currentDiscountValue"
            dense
            v-money="currentDiscountType === 'percentual' ? percentual : valor"
          ></v-text-field>
          <v-row align="center" class="text-center">
            <v-col cols="6">
              <div class="subtotal-label">Total</div>
              <div class="subtotal-value">{{ currentTotal }}</div>
            </v-col>
            <v-col cols="6">
              <div class="subtotal-label">Total com desconto</div>
              <div class="subtotal-value">{{ discountedTotal }}</div>
            </v-col>
          </v-row>
          <div class="discount-label">
            Desconto: {{ this.calculateDiscountResume() }}
          </div>
        </v-card-text>
      </v-form>

      <v-footer class="save-button" absolute app>
        <v-btn block color="primary" @click="handleSave" class="mb-2">
          Salvar
        </v-btn>
      </v-footer>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'Discount',
  emits: ['close', 'select'],
  props: {
    isActive: {
      type: Boolean,
      default: false,
    },
    total: {
      type: String,
      default: null,
    },
    totalServices: {
      type: String,
      default: null,
    },
    totalProducts: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      activeTab: 0, // 0 = serviços, 1 = produtos
      // Modo legado (antigo)
      discountType: 'percentual',
      discountValue: '0,00 %',
      // Novo modo - Serviços
      discountTypeServices: 'percentual',
      discountValueServices: '0,00 %',
      // Novo modo - Produtos
      discountTypeProducts: 'percentual',
      discountValueProducts: '0,00 %',
      // Configurações de formatação
      valor: {
        decimal: ',',
        thousands: '.',
        prefix: 'R$ ',
        suffix: '',
        precision: 2,
        masked: true,
      },
      percentual: {
        decimal: ',',
        thousands: '.',
        prefix: '',
        suffix: ' %',
        precision: 2,
        masked: true,
      },
    };
  },
  watch: {
    selectedBudget: {
      immediate: true,
      deep: true,
      handler(newValue) {
        if (!newValue) return;

        // Verificar modo diretamente do newValue
        const { discount, discount_type: discountType } = newValue;

        const hasLegacyDiscount =
          discount !== null &&
          discount !== undefined &&
          discount !== '' &&
          discount !== 0 &&
          parseFloat(discount) > 0;

        const hasLegacyType =
          discountType !== null &&
          discountType !== undefined &&
          discountType !== '';

        const isLegacy = hasLegacyDiscount || hasLegacyType;

        if (isLegacy) {
          // Modo legado
          this.discountType = newValue.discount_type || 'percentual';
          this.discountValue = this.handleFormatReturn(
            newValue.discount || '0.00',
            this.discountType,
          );
        } else {
          // Novo modo separado
          this.discountTypeServices =
            newValue.discount_type_services || 'percentual';
          this.discountValueServices = this.handleFormatReturn(
            newValue.discount_services || '0.00',
            this.discountTypeServices,
          );
          this.discountTypeProducts =
            newValue.discount_type_products || 'percentual';
          this.discountValueProducts = this.handleFormatReturn(
            newValue.discount_products || '0.00',
            this.discountTypeProducts,
          );

          // Definir a aba correta baseado em qual tem desconto
          const hasServicesDiscount =
            parseFloat(newValue.discount_services || 0) > 0;
          const hasProductsDiscount =
            parseFloat(newValue.discount_products || 0) > 0;

          if (hasProductsDiscount && !hasServicesDiscount) {
            this.activeTab = 1;
          } else if (hasServicesDiscount) {
            this.activeTab = 0;
          } else {
            this.activeTab = 0;
          }
        }

        this.$nextTick(() => {
          this.updateInputValue();
        });
      },
    },
    activeTab() {
      // A key dinâmica no v-text-field força a recriação do componente
    },
    isActive(newValue) {
      if (newValue) {
        setTimeout(() => {
          this.initializeValues();
          setTimeout(() => {
            if (this.$refs.discountValue) {
              const inputEl =
                this.$refs.discountValue.$el.getElementsByTagName('input')[0];
              if (inputEl) {
                inputEl.value = this.currentDiscountValue;
              }
            }
          }, 150);
        }, 100);
      }
    },
    currentDiscountValue(newValue) {
      if (!newValue || typeof newValue !== 'string') return;

      let cleanValue = newValue.replace('%', '').replace('R$', '').trim();
      cleanValue = cleanValue.replace(/\./g, '').replace(',', '.');
      const discountValue = parseFloat(cleanValue) || 0;

      if (this.currentDiscountType === 'percentual') {
        if (discountValue > 100) {
          this.setCurrentDiscountValue('100,00 %');
          if (this.$refs.discountValue) {
            this.$refs.discountValue.$el.getElementsByTagName(
              'input',
            )[0].value = '100,00 %';
          }
        }
      }
    },
  },
  computed: {
    ...mapState('Budget', ['selectedBudget']),
    isLegacyMode() {
      if (!this.selectedBudget) return true;

      const { discount, discount_type: discountType } = this.selectedBudget;

      const hasLegacyDiscount =
        discount !== null &&
        discount !== undefined &&
        discount !== '' &&
        discount !== 0 &&
        parseFloat(discount) > 0;

      const hasLegacyType =
        discountType !== null &&
        discountType !== undefined &&
        discountType !== '';

      return hasLegacyDiscount || hasLegacyType;
    },
    currentDiscountType: {
      get() {
        if (this.isLegacyMode) {
          return this.discountType;
        }
        return this.activeTab === 0
          ? this.discountTypeServices
          : this.discountTypeProducts;
      },
      set(value) {
        if (this.isLegacyMode) {
          this.discountType = value;
        } else if (this.activeTab === 0) {
          this.discountTypeServices = value;
        } else {
          this.discountTypeProducts = value;
        }
      },
    },
    currentDiscountValue: {
      get() {
        if (this.isLegacyMode) {
          return this.discountValue;
        }
        return this.activeTab === 0
          ? this.discountValueServices
          : this.discountValueProducts;
      },
      set(value) {
        if (this.isLegacyMode) {
          this.discountValue = value;
        } else if (this.activeTab === 0) {
          this.discountValueServices = value;
        } else {
          this.discountValueProducts = value;
        }
      },
    },
    currentTotal() {
      if (this.isLegacyMode) {
        return this.total;
      }
      return this.activeTab === 0
        ? this.totalServices || this.calculateServicesTotal()
        : this.totalProducts || this.calculateProductsTotal();
    },
    discountedTotal() {
      let discountedTotal;
      const total = this.parseCurrency(this.currentTotal);

      if (this.currentDiscountType === 'percentual') {
        let discount;

        if (typeof this.currentDiscountValue === 'string') {
          const percentualValue = this.currentDiscountValue
            .replace('%', '')
            .trim();
          const percentualValueWithoutDot = percentualValue.replace('.', '');
          const percentualValueWithoutComma = percentualValueWithoutDot.replace(
            ',',
            '.',
          );
          discount = percentualValueWithoutComma / 100;
        } else {
          discount = this.currentDiscountValue / 100;
        }

        const valorComDesconto = total - total * discount;
        discountedTotal = valorComDesconto;
      } else if (this.currentDiscountType === 'valor') {
        const discount = this.parseCurrency(this.currentDiscountValue);
        discountedTotal = total - discount;
      } else {
        discountedTotal = total;
      }

      return this.formatCurrency(discountedTotal);
    },
  },
  methods: {
    initializeValues() {
      if (!this.selectedBudget) return;

      if (this.isLegacyMode) {
        this.discountType = this.selectedBudget.discount_type || 'percentual';
        this.discountValue = this.handleFormatReturn(
          this.selectedBudget.discount || '0.00',
          this.discountType,
        );
      } else {
        const hasServicesDiscount =
          parseFloat(this.selectedBudget.discount_services || 0) > 0;
        const hasProductsDiscount =
          parseFloat(this.selectedBudget.discount_products || 0) > 0;

        if (hasProductsDiscount && !hasServicesDiscount) {
          this.activeTab = 1;
        } else if (hasServicesDiscount) {
          this.activeTab = 0;
        } else {
          this.activeTab = 0;
        }

        this.discountTypeServices =
          this.selectedBudget.discount_type_services || 'percentual';
        this.discountValueServices = this.handleFormatReturn(
          this.selectedBudget.discount_services || '0.00',
          this.discountTypeServices,
        );
        this.discountTypeProducts =
          this.selectedBudget.discount_type_products || 'percentual';
        this.discountValueProducts = this.handleFormatReturn(
          this.selectedBudget.discount_products || '0.00',
          this.discountTypeProducts,
        );
      }

      setTimeout(() => {
        if (this.$refs.discountValue) {
          const inputEl =
            this.$refs.discountValue.$el.getElementsByTagName('input')[0];
          if (inputEl) {
            inputEl.value = this.currentDiscountValue;
            inputEl.dispatchEvent(new Event('input'));
          }
        }
      }, 50);
    },
    calculateServicesTotal() {
      if (!this.selectedBudget?.budget_services) {
        return this.formatCurrency(0);
      }
      const total = this.selectedBudget.budget_services
        .filter((service) => service.disaproved_by_client !== true)
        .reduce(
          (acc, service) => acc + parseFloat(service.total_value || 0),
          0,
        );
      return this.formatCurrency(total);
    },
    calculateProductsTotal() {
      if (!this.selectedBudget?.budget_products) {
        return this.formatCurrency(0);
      }
      const total = this.selectedBudget.budget_products
        .filter((product) => product.disaproved_by_client !== true)
        .reduce(
          (acc, product) => acc + parseFloat(product.total_value || 0),
          0,
        );
      return this.formatCurrency(total);
    },
    setCurrentDiscountValue(value) {
      if (this.isLegacyMode) {
        this.discountValue = value;
      } else if (this.activeTab === 0) {
        this.discountValueServices = value;
      } else {
        this.discountValueProducts = value;
      }
    },
    updateInputValue() {
      if (this.$refs.discountValue) {
        this.$refs.discountValue.$el.getElementsByTagName('input')[0].value =
          this.currentDiscountValue;
      }
    },
    close() {
      if (this.isLegacyMode) {
        this.discountType = this.selectedBudget.discount_type || 'percentual';
        this.discountValue = this.handleFormatReturn(
          this.selectedBudget.discount || '0.00',
          this.discountType,
        );
      } else {
        this.discountTypeServices =
          this.selectedBudget.discount_type_services || 'percentual';
        this.discountValueServices = this.handleFormatReturn(
          this.selectedBudget.discount_services || '0.00',
          this.discountTypeServices,
        );
        this.discountTypeProducts =
          this.selectedBudget.discount_type_products || 'percentual';
        this.discountValueProducts = this.handleFormatReturn(
          this.selectedBudget.discount_products || '0.00',
          this.discountTypeProducts,
        );
      }

      this.$nextTick(() => {
        this.updateInputValue();
      });

      this.$emit('close');
    },
    handleFormatReturn(value, type) {
      const numValue = parseFloat(value) || 0;
      const valueFormatted = numValue.toFixed(2).replace('.', ',');

      return type === 'percentual'
        ? `${valueFormatted} %`
        : `R$ ${valueFormatted}`;
    },
    calculateDiscountAmount() {
      const total = this.parseCurrency(this.currentTotal);

      const valorSemSimboloNegativo = this.discountedTotal
        .replace('-', '')
        .trim();
      const discountedTotal = this.parseCurrency(valorSemSimboloNegativo);

      return total - discountedTotal;
    },
    calculateDiscountResume() {
      const discountAmount = this.calculateDiscountAmount();
      const total = this.parseCurrency(this.currentTotal);
      const discountPercentual =
        discountAmount > 0 && total > 0 ? (discountAmount / total) * 100 : 0;

      return `${this.formatCurrency(
        discountAmount,
      )} ( ${discountPercentual.toFixed(2)}% )`;
    },
    parseCurrency(value) {
      return value
        ? parseFloat(
            value.replace('R$', '').replace(/\./g, '').replace(',', '.').trim(),
          )
        : 0;
    },
    formatCurrency(value) {
      if (Number.isNaN(value)) {
        return '';
      }

      const formattedValue = parseFloat(value).toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      if (value < 0) {
        return `-${formattedValue.replace('-', '')}`;
      }

      return formattedValue;
    },
    handleSave() {
      if (this.isLegacyMode) {
        // Modo legado - emite como antes
        const discountValue = this.discountValue
          .replace('R$ ', '')
          .replace(' %', '')
          .trim();

        this.$emit('select', {
          type: this.discountType,
          value: discountValue,
        });
      } else {
        // Novo modo - emite separado por serviço e produto
        const discountValueServices = this.discountValueServices
          .replace('R$ ', '')
          .replace(' %', '')
          .trim();

        const discountValueProducts = this.discountValueProducts
          .replace('R$ ', '')
          .replace(' %', '')
          .trim();

        this.$emit('select', {
          discount_type_services: this.discountTypeServices,
          discount_services: discountValueServices,
          discount_type_products: this.discountTypeProducts,
          discount_products: discountValueProducts,
          isNewMode: true,
        });
      }

      this.$emit('close');
    },
    toggleDiscountType() {
      this.$refs.discountValue.$el.getElementsByTagName('input')[0].value =
        this.handleFormatReturn('0.00', this.currentDiscountType);
      this.setCurrentDiscountValue(
        this.handleFormatReturn('0.00', this.currentDiscountType),
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.save-button {
  background-color: #ffffff !important;
  color: #fff;
}

.discount-tabs {
  margin-bottom: 8px;
  width: 100%;

  :deep(.v-tabs-bar) {
    width: 100%;
  }

  :deep(.v-tab) {
    font-weight: 600;
    width: 50%;
    max-width: none;
    flex: 1;
  }

  :deep(.v-tab--active) {
    border: 2px solid #000;
    border-radius: 4px;
  }
}

.discount-label {
  margin-top: 16px;
  padding: 8px;
  background-color: #f5f5f5;
  color: rgba(0, 0, 0, 0.87);
  font-size: 14px;
  text-align: center;
}

.subtotal-label {
  font-size: 12px;
  color: rgba(0, 0, 0, 0.54);
}

.subtotal-value {
  font-size: 16px;
  font-weight: 500;
}

:deep(input) {
  text-align: center !important;
}

.type-selector {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.header {
  width: 100%;
  z-index: 999;
  border-radius: 0px !important;

  .content-header {
    padding: 20px 20px;
    background-color: #3e515f;
    color: #fff;

    .return-screen {
      float: right;
      background-color: #2d3c47;
      border-radius: 50%;
      padding: 10px;
      margin-top: 5px;
    }
  }
}
</style>
